module.exports = __webpack_public_path__ + "img/dialed_call_icon.850d5c22.svg";